<template>
 <div>
    <div v-for="(item,i) in Value" :key="i" style="margin-bottom:10px">
      <el-input :placeholder="placeholder" v-model="item.value" @mousedown.stop.native @click.stop.native :class="'courier_'+i"></el-input>
      <el-button style="margin-left:10px" type="text" @click.stop.native="deleteItem(i)">删除</el-button><br>
      <el-button type="text" @click.stop.native="addItem(i)" v-show="i==Value.length-1">添加一条</el-button>
    </div>
 </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default:()=>[{value:''}]
    },
    placeholder:{
      type:String,
      default:'请填写'
    }
  },
  data () {
    return {
      Value: this.value ? this.value : [{value:''}],
    }
  },
  watch: {
    value (val) {
      this.Value = val
    },
    Value (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    addItem (index) {
      if (this.Value[index].value === '') {
        this.$message.error('请填写！')
        return
      }
      this.Value.push({value:''})
      this.$nextTick(() => {
        document.querySelector('.courier_' + (index + 1) + '>input').focus()
      })
    },
    deleteItem (index) {
      if (index === 0 && this.Value.length === 1) {
        this.$message.error('不能再删除了')
        return
      }
      this.$confirm('确定要删除该条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.Value.splice(index, 1)
      })
    },
  }
}
</script>

<style>

</style>
